import Vue from 'vue';
import { mergeContactRecord } from 'dashboard/helper/contactMeetingUiSync';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_CONTACT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_CONTACTS]: $state => {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_CONTACT_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
  },

  [types.SET_CONTACTS]: ($state, data) => {
    const sortOrder = data.map(contact => {
      Vue.set(
        $state.records,
        contact.id,
        mergeContactRecord($state.records[contact.id] || {}, contact)
      );
      return contact.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_CONTACT_ITEM]: ($state, data) => {
    Vue.set(
      $state.records,
      data.id,
      mergeContactRecord($state.records[data.id] || {}, data)
    );

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.EDIT_CONTACT]: ($state, data) => {
    Vue.set(
      $state.records,
      data.id,
      mergeContactRecord($state.records[data.id] || {}, data)
    );
  },

  [types.DELETE_CONTACT]: ($state, id) => {
    const index = $state.sortOrder.findIndex(item => item === id);
    Vue.delete($state.sortOrder, index);
    Vue.delete($state.records, id);
  },

  [types.UPDATE_CONTACTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach(element => {
      const availabilityStatus = data[element.id];
      if (availabilityStatus) {
        Vue.set(
          $state.records[element.id],
          'availability_status',
          availabilityStatus
        );
      } else {
        Vue.delete($state.records[element.id], 'availability_status');
      }
    });
  },

  [types.SET_CONTACT_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },
    [types.SET_CONTACT_ACTIONS](_state, data) {
    _state.appliedActions = data;
  },


  [types.CLEAR_CONTACT_FILTERS](_state) {
    _state.appliedFilters = [];
    _state.appliedActions=[];
  },
  [types.TOGGLE_AUTH_STATUS_TRUE](state) {
    state.isIncoming = true;
  },

  [types.TOGGLE_AUTH_STATUS_FALSE](state) {
    state.isIncoming = false;
  },

  [types.TOGGLE_HOLD_STATUS_TRUE](state) {
    state.isHold = true;
  },

  [types.TOGGLE_HOLD_STATUS_FALSE](state) {
    state.isHold = false;
  },

  [types.TOGGLE_HOLD_CALL_AVAILABLE_STATUS_TRUE](state) {
    state.isHoldui=true;
  },

  [types.TOGGLE_HOLD_CALL_AVAILABLE_STATUS_FALSE](state) {
    state.isHoldui=false;
  },

  [types.CALL_HOLD]: (state,data)=> {
    state.holdcalldata=data;
    const callsArray = [];
    for (const key in data) {
      if (key !== 'account_id' && key !== 'count' && key.startsWith('call_')) {
        callsArray.push(data[key]);
      }
    }
    state.holdCall=callsArray;
  },
};
